<template>
  <b-modal :id="id"
           lazy
           centered
           ok-variant="ls"
           size="lg"
           title="Włącz powiadomienia z aplikacji, aby być zawsze na bieżąco."
           cancel-title="Blokuj"
           footer-class="justify-content-between"
           :ok-title="okTitle"
           @ok="handleOk"
           @cancel="neverShowAgain"
           hide-header
           no-stacking
  >
    <div class="text-center mt-3">
      <h3>Włącz powiadomienia i bądź na bieżąco.</h3>
    </div>
  </b-modal>
</template>

<script>
import {mapState} from "vuex";
import messaging from "@/utils/FirebaseCloudMessaging";
import {getToken} from "firebase/messaging";
import {isIosApp} from "@/utils/Pwa";

export default {
  name: "NotificationsPermissionModal",
  data() {
    return {
      id: 'notifications-permission-modal',
      okTitle: 'Włącz',
      token: '',
      tokenExists: false,
    }
  },
  mounted() {
    if (!this.isAuthorized ||  !this.push.enabled || this.dismissModal) {
      return;
    }
    let tokenFromStorage = localStorage.getItem('ls-fcm-token');
    if (("Notification" in window)) {
      if (Notification.permission === 'granted') {
        this.getMessagingToken()
            .then(token => this.checkTokenExists(token))
            .then((tokenExists) => {
              if (!tokenExists) {
                this.$bvModal.show(this.id);
              }
            });
        return;
      }

      if (Notification.permission === "denied") {
        return; // user denied notifications
      }
      setTimeout(() => this.$bvModal.show(this.id), 1000);
    }else if(!tokenFromStorage){  //todo tylko na ios?
      return;
    }

    if(isIosApp && tokenFromStorage){
      this.getMessagingToken()
          .then(token => this.checkTokenExists(token))
          .then((tokenExists) => {
            if (!tokenExists) {
              this.createPushToken(tokenFromStorage);
            }
          });
    }
  },
  methods: {
    handleOk() {
      if (this.tokenExists) {
        this.createPushToken(this.token);
      } else {
        this.requestPermission();
      }
    },
    requestPermission() {
      if (!this.isAuthorized) {
        return;
      }
      if (("Notification" in window)) {
        Notification.requestPermission()
            .then(permission => {
              if (permission !== 'granted') {
                return;
              }

              this.getMessagingToken().then(token => this.createPushToken(token)).then(() => localStorage.setItem(this.pushTokenExistsStorageKey, true));
            });
      }else if(isIosApp){  //todo check if ios and permissions are granted from ios
        this.getMessagingToken().then(token => this.createPushToken(token)).then(() => localStorage.setItem(this.pushTokenExistsStorageKey, true));
      }
    },
    getMessagingToken() {
      if (isIosApp && localStorage.getItem('ls-fcm-token')) {
        let token = localStorage.getItem('ls-fcm-token');
        this.token = token;
        return new Promise((resolve) => {
          resolve(token);
        });
      }
      if (!messaging) {
        return new Promise((resolve, reject) => {
          reject('No Messaging API');
        });
      }

      return getToken(messaging)
          .then((token) => {
            this.token = token;
            return token;
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.log('Err:', e)
          })
    },
    checkTokenExists(token) {
      if (!token) {
        return;
      }

      return this.$http.post('/push/token/exists', {token})
          .then(r => {
            if(r.data.success && !r.data.userMatch){
              this.createPushToken(token,true);
            }
            this.tokenExists = r.data.success
            // eslint-disable-next-line no-console
            localStorage.setItem(this.pushTokenExistsStorageKey, !!r.data.success);
            return this.tokenExists;
          });
    },
    createPushToken(token,hideMessage = false) {
      return this.$http.post('push/token', {token,hideMessage});
    },
    neverShowAgain() {
      localStorage.setItem(this.dismissStorageKey, true);
    },
  },
  computed: {
    ...mapState({
      entityUuid: state => state.auth.entity.uuid,
      isAuthorized: state => state.auth.isAuthorized,
      push: state => state.settings.push
    }),
    dismissStorageKey() {
      return `ls-dismiss-notifications-${this.entityUuid}`;
    },
    pushTokenExistsStorageKey() {
      return `ls-push-token-${this.entityUuid}`;
    },
    dismissModal() {
      return localStorage.getItem(this.dismissStorageKey) === 'true';
    },
  }
}
</script>

<style scoped>

</style>
